import { createTracker as createTrackerInternal } from 'usage-tracker-hubtools';
import { createTracker as createTrackerApp } from 'usage-tracker';
import Raven from 'raven-js';
import events from '../events.yaml';
const createTracker = window.location.href.includes('hubteam') ? createTrackerInternal : createTrackerApp;
export default createTracker({
  events,
  onError: err => {
    console.error(err);
    Raven.captureException(err, {
      extra: {
        err
      }
    });
  }
});